export default str => str ? str.replace(/<p[^>]*>(&nbsp;|\s+)<\/p>/gim, '') : str;
